import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
